export default __webpack_public_path__ + "static/media/contact_bg.7e5217df.png";